import 'react-circular-progressbar/dist/styles.css';
import 'react-datepicker/dist/react-datepicker.css';
import HeaderQuoteAi from './headerQuoteAi';

const AlfredAlertPage = () => {
  return (
    <>
      <div id="quoteAi">
        <HeaderQuoteAi />

        <div className="fullAlfredAlert_dashboard"></div>
      </div>
    </>
  );
};
export default AlfredAlertPage;
